/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Typography from "@material-ui/core/Typography";
import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AuthApi from "../../Services/Authapi";
import swal from "sweetalert";
import moment from "moment";
import AuthCheckComponent from "../../Layouts/Token";
import { createSwalLoaderNode } from "../../Layouts/swalLoader";

const inileaves = {
  leaveName: "",
  date: "",
};

const AddLeaves = (props) => {
  const classes = props;
  const [leaveValues, setLeaveValues] = useState(inileaves);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getFinancialYearForDate = (date) => {
    const parsedDate = moment(date, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"], true);
    if (!parsedDate.isValid()) {
      return null;
    }

    const startYear = parsedDate.month() >= 3 ? parsedDate.year() : parsedDate.year() - 1;
    return `${startYear}-${startYear + 1}`;
  };

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push("/login");
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeaveValues({ ...leaveValues, [name]: value });

    // if (name === "date") {
    //   const selectedDate = moment(value, "YYYY-MM-DD");
    //   const dayOfWeek = selectedDate.day();
    //   const tomorrow = moment().add(1, 'days').startOf('day');

    //   if (selectedDate.isBefore(tomorrow)) {
    //     swal({
    //       title: "Invalid Date",
    //       text: "The selected date cannot be today or in the past.",
    //       icon: "error",
    //     });
    //   } else if (dayOfWeek === 6 || dayOfWeek === 0) {
    //     swal({
    //       title: "Invalid Date",
    //       text: "Weekends are not allowed",
    //       icon: "error",
    //     });
    //     setLeaveValues({ ...leaveValues, date: "" });
    //   }
    // }
  };

  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z]/;
    const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    if (!values.leaveName) {
      errors.leaveName = "Cannot be blank";
    } else if (!regex.test(values.leaveName)) {
      errors.leaveName = "Invalid leave name format";
    }

    if (!values.date) {
      errors.date = "Cannot be blank";
    } else if (!dateR.test(values.date)) {
      errors.date = "Invalid date format";
      // } else {
      //   const selectedDate = moment(values.date, "YYYY-MM-DD");
      //   const dayOfWeek = selectedDate.day();
      //   if (dayOfWeek === 6 || dayOfWeek === 0) {
      //     errors.date = "Weekends are not allowed";
      //   }
      // }
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(leaveValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setIsSubmitting(true);
    } else if (errors.date) {
      swal({
        title: "Invalid Date",
        text: errors.date,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
      createLeaves();
    }
  }, [formErrors]);

  const createLeaves = async () => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode(),
    });
    try {
      const formattedDate = moment(leaveValues.date, "YYYY-MM-DD").format("DD-MM-YYYY");
      const dataToSend = { ...leaveValues, date: formattedDate };

      let response = await AuthApi.createHoliday(dataToSend);
      swal.close();
      if (response && response.status === true) {
        const selectedYear = getFinancialYearForDate(leaveValues.date);
        swal("Success", "Holiday added successfully", "success").then(() => {
          props.history.push({
            pathname: "/holiday-leaves",
            state: {
              selectedYear,
              date: formattedDate,
            },
          });
        });
      } else {
        const errorMessage = response.message || "An error occurred.";
        swal({
          title: "OOPS",
          text: errorMessage,
          icon: "error",
        });
      }
    } catch (error) {
      swal.close();
      console.error("Error creating leave:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while creating the leave.";
      swal({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <Card className={classes.root} style={{ marginBottom: "3%" }}>
              <CardContent>
                <Breadcrumb
                  {...props}
                  primaryPageName="Holidays"
                  primaryPageLink="/holiday-leaves"
                  isSecondaryPage={true}
                  secondaryPageName="Add Holiday"
                />
              </CardContent>
            </Card>
            <Grid container className={classes.root} spacing={2}>
              <Grid item xs={12}>
                <Card className={classes.root}>
                  <CardContent>
                    <Typography variant="h2">Add Holiday Leave</Typography>
                    <form className={classes.form} onSubmit={handleSubmit}>
                      <Grid container className={classes.root} spacing={5}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            id="leaveName"
                            name="leaveName"
                            label="Holiday Name"
                            variant="outlined"
                            error={formErrors.leaveName && true}
                            value={leaveValues.leaveName}
                            onChange={handleChange}
                            className={formErrors.leaveName && "input-error"}
                            inputProps={{ maxLength: 100 }}
                          />
                          {formErrors.leaveName && (
                            <span className="error">
                              {formErrors.leaveName}
                            </span>
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            id="date"
                            variant="outlined"
                            label="Date"
                            name="date"
                            type="date"
                            error={formErrors.date && true}
                            value={leaveValues.date}
                            onChange={handleChange}
                            className={`${classes.textField} ${formErrors.date ? "input-error" : ""}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          // inputProps={{
                          //   min: moment().add(1, 'days').format("YYYY-MM-DD"),
                          // }}
                          />
                          {formErrors.date && (
                            <span className="error">{formErrors.date}</span>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={4} style={{ display: "flex" }}>
                          <Button
                            type="submit"
                            style={{ marginTop: "10px", textTransform: 'none' }}
                            variant="contained"
                            color="primary"
                          >
                            Save
                          </Button>
                          <Button
                            type="button"
                            style={{ marginTop: "10px", textTransform: 'none' }}
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/holiday-leaves");
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default AddLeaves;
